<template>
  <div class="content">
    <div class="user-info">
      <!-- Аватар пользователя и подпись -->
      <div class="avatar">
        <img
          src="https://raw.githubusercontent.com/itchief/modx-solutions/main/Login/04-upload-photo/01-default.svg"
          alt="User Avatar"
        />
        <p v-if="user.signature" class="signature-info">Подпись добавлена</p>
        <SignatureUpload />
      </div>

      <!-- Детали пользователя -->
      <div class="user-details">
        <!-- Имя пользователя -->
        <div class="info-text">
          <p><strong>Имя:</strong> {{ user.name }}</p>
        </div>

        <!-- Email пользователя -->
        <div class="info-text">
          <p><strong>Email:</strong> {{ user.email }}</p>
        </div>

        <!-- Телефон -->
        <div class="info-text">
          <p><strong>Телефон:</strong>
            <span v-if="!redact">{{ user.phone }}</span>
            <input v-else v-model="form.phone" type="text" class="input input-phone" />
          </p>
        </div>

        <!-- ATI Token -->
        <div class="form-group">
          <label for="atiToken">ATI Token:</label>
          <span v-if="!redact">{{ user.ati_token }}</span>
          <input v-else v-model="form.ati_token" id="atiToken" type="text" class="input" />
        </div>

        <!-- Telegram -->
        <div class="form-group tg-connect">
          <label>Telegram:</label>
          <div class="telegram-values">
            <span>{{ user.tg_username || 'Не подключён' }}</span>
            <small v-if="user.tg_chat_id">Уведомления подключены</small>
            <small v-else-if="tgBind">Код действует 15 минут</small>
          </div>
          <a
            v-if="!user.tg_chat_id && !tgBind"
            href="#"
            class="tg-action-link"
            title="Подключить Telegram через бота"
            @click.prevent="requestBindCode"
          >Подключить</a>
          <a
            v-if="!user.tg_chat_id && tgBind"
            :href="tgBind.bind_url"
            class="tg-action-link"
            target="_blank"
            title="Перейти к боту для привязки"
          >Открыть бота</a>
          <a
            v-if="!user.tg_chat_id && tgBind"
            href="#"
            class="tg-action-link"
            @click.prevent="refreshUser"
          >Готово</a>
          <a
            v-if="user.tg_chat_id"
            href="#"
            class="tg-action-link tg-action-danger"
            @click.prevent="disconnectTg"
          >Отключить</a>
        </div>

        <!-- Кнопки управления -->
        <div class="actions">
          <button v-if="redact" @click="updateUser">Сохранить</button>
          <button v-if="redact" @click="cancelEdit">Отмена</button>
          <button v-else @click="enableEdit">Изменить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import SignatureUpload from '@/pages/users/SignatureUpload';
import ApiConnector from '@/backend/auth/auth.js';

const api = new ApiConnector();

export default {
  components: { SignatureUpload },
  setup() {
    const redact = ref(false); // Флаг редактирования
    const tgBind = ref(null); // { bind_url, expires_at } — активный код привязки
    const store = useStore();
    const user = computed(() => store.state.user.user || {});

    const form = ref({
      id: user.value.id,
      ati_token: user.value.ati_token,
      phone: user.value.phone,
    });

    const requestBindCode = async () => {
      try {
        const response = await api.createTgBindCode();
        tgBind.value = response.data;
      } catch (e) {
        tgBind.value = null;
      }
    };

    const refreshUser = () => {
      tgBind.value = null;
      store.dispatch('getUser');
    };

    const disconnectTg = async () => {
      try {
        await api.disconnectTg();
      } finally {
        tgBind.value = null;
        store.dispatch('getUser');
      }
    };

    const updateUser = () => {
      store.dispatch('updateUser', form.value);
      redact.value = false; // Выход из режима редактирования
    };

    const cancelEdit = () => {
      form.value = {
        id: user.value.id,
        ati_token: user.value.ati_token,
        phone: user.value.phone,
      }; // Восстанавливаем редактируемые данные пользователя
      redact.value = false;
    };

    const enableEdit = () => {
      form.value = {
        id: user.value.id,
        ati_token: user.value.ati_token,
        phone: user.value.phone,
      };
      redact.value = true; // Включаем режим редактирования
    };

    return {
      redact,
      user,
      form,
      tgBind,
      requestBindCode,
      refreshUser,
      disconnectTg,
      updateUser,
      cancelEdit,
      enableEdit,
    };
  },
};
</script>

<style scoped>
.content {
  margin: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.user-info {
  display: flex;
  gap: 20px;
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 40%;
}

.info-text{
  padding: 5px 0px;
}

.signature-info {
  font-size: 10px;
  margin-bottom: 10px;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.avatar img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.form-group {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
}

input {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.input-phone{
  margin-left: 5px;
}

.actions {
display: flex;
gap: 10px;
}

.actions button {
padding: 5px 10px;
font-size: 14px;
cursor: pointer;
}


button {
  padding: 8px 15px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.tg-connect{
  display: flex;
  align-items: center;
}

.tg-action-link {
  text-decoration: none;
  color: #007BFF;
  font-size: 14px;
  margin-left: 10px;
}

.tg-action-link:hover {
  text-decoration: underline;
}

.tg-action-danger {
  color: #dc2626;
}

/* .icon{
  border: 1px solid #ccc;
  width: 20px;
  height: 20px;
  padding: 4px;
  margin-left: 17px;
  background-color: white;
} */

.tg-connect{
  display: flex;
  align-items: center;
}

.telegram-values {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.telegram-values small {
  color: #666;
}

@media screen and (max-width: 769px) {
  .user-info {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
}
</style>
